import Olympiads from './olympiads';

export default Olympiads;
